// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bbc90a39","455":"4824c108","977":"adc8cf90"}[chunkId] + ".chunk.js";
};